import styled from '@emotion/styled';
import { themeVariables } from '../../themeVariables';

export const DialogComponentStyled = styled.div`
  padding: 1rem 1rem 1rem 1rem;

  .MuiTypography-root-MuiDialogTitle-root {
    font-size: ${themeVariables.fontSizes.xLarge} !important;
  }
`;
